import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router'
import { EnrichedInvite } from '../../stores/inviteStore'

export interface InviteCardProps {
  invite: EnrichedInvite
}

const formatDateTime = (timestamp: { toDate: () => Date }): string => {
  const date = timestamp.toDate()
  return date.toLocaleDateString('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const formatDistance = (distanceKm: number | null): string => {
  if (distanceKm == null) return 'Distance unknown'
  return `${Math.round(distanceKm)}km`
}

const InviteCard = ({ invite }: InviteCardProps) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/dives/${invite.diveId}`)
  }

  return (
    <Card variant='outlined'>
      <CardActionArea onClick={handleClick}>
        <CardContent>
          <Typography
            variant='subtitle1'
            component='h3'
            sx={{ fontWeight: 600 }}
          >
            {invite.hostDisplayName}
          </Typography>

          <Typography variant='body2' color='text.secondary' gutterBottom>
            {invite.diveSiteName}
          </Typography>

          <Typography variant='body2' color='text.secondary' gutterBottom>
            {formatDateTime(invite.diveDateTime)}
          </Typography>

          <Typography variant='body2' color='text.secondary'>
            {formatDistance(invite.distanceKm)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default InviteCard
